/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateSuggestionRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/cash_suggestions.pb'
import {UpdateSuggestionResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/cash_suggestions.pb'


export const updateSuggestion = (request: UpdateSuggestionRequest, options?: CashRequestOptions) => post<UpdateSuggestionRequest, UpdateSuggestionResponse>("/cash-app/goose-cash/v3/update-suggestion", request, {...options, rejectOnError: true })